import _ from 'lodash';
import { getUser } from '~src/user';
import editorConfig from '~config/editorConfig';
import { op as openpanel, debug, isLocalhost } from './config/openpanelConfig';
import { trackGleapEvent } from './initGleap';

export const trackEvent = (eventName = '', options = {}) => {
  if (isLocalhost) {
    return;
  }
  getUser().then(({ user }) => {
    if (
      (editorConfig.excludeFromTrackingOrgsIds.includes(
        user.org_pointer.objectId
      ) ||
        editorConfig.excludeFromTrackingOrgsNames.includes(
          user.org_pointer.nome
        )) &&
      !debug
    ) {
      console.debug(
        `[tracking] excluding orgId: ${user.org_pointer.objectId} orgName: ${user.org_pointer.nome}`
      );
      return;
    }

    const eventData = {
      ...options,
      app: 'giotto',
    };

    try {
      if (openpanel) {
        openpanel.track(eventName, eventData);
      }
    } catch (error) {
      console.error('Error tracking event in OpenPanel', error);
    }

    trackGleapEvent(eventName, eventData);

    if (debug) {
      console.log('trackEvent', eventName, options);
    }
  });
};

export const trackEventDebounced = _.debounce(
  (eventName = '', options = {}) => {
    trackEvent(eventName, options);
  },
  3000
);
